<template>
  <div>
    <b-form-datepicker v-model="date"
    :class="{'is-invalid' : error}"
    :name="`formData[${currentField.tagname}]`" :required="this.currentField.isRequired"></b-form-datepicker>
    <span class="invalid-feedback" role="alert" v-if="error">
        <strong>{{ error }}</strong>
    </span>
  </div>
</template>


<script>
  export default {
    name: 'DatePicker',
    props: ['currentField', 'error'],
    data() {
      return {
        date: ''
      }
    }
  }
</script>
